import { Checkbox, FormControlLabel } from '@mui/material';
import axios from 'axios';
import { useTranslation } from 'next-i18next';
import dynamic from 'next/dynamic';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import VyButton from '../common/VyButton';
import VyModal from '../common/VyModal';

const VyRichTextEditor = dynamic(() => import('../common/VyRichTextEditor'), {
  ssr: false,
  loading: () => <p>loading...</p>,
});

interface EmailGuestModalProps {
  emails: string[];
  boothId: string;
  onClose?: () => void;
}

export default function EmailGuestModal(props: EmailGuestModalProps) {
  const { t } = useTranslation(['toasts', 'account', 'common']);
  const [content, setContent] = useState<string>('');
  const {
    handleSubmit,
    register,
    formState: { isSubmitting },
  } = useForm();

  async function sendMail(data: any) {
    console.log('---sendmail');
    if (!content) return;
    await axios
      .post('/booth/followup', {
        emails: props.emails,
        boothid: props.boothId,
        content,
        ccMe: data.ccMe,
      })
      .then(({ data }) => {
        setContent('');
        console.log('sent attendee mails', data.data);
        props.onClose && props.onClose();
      });
  }

  return (
    <>
      <VyModal maxWidth="90vw" open={props.emails.length > 0} onClose={() => props.onClose && props.onClose()} title={t('account:contact-contactshare')}>
        {() => (
          <>
            <form onSubmit={handleSubmit(sendMail)}>
              <VyRichTextEditor defaultValue={content} onBlur={(desc: string) => setContent(desc)} />
              <div className="flex justify-between items-center">
                <FormControlLabel
                  control={<Checkbox defaultChecked={false} />}
                  className="checkLabel"
                  {...register('ccMe')}
                  labelPlacement="start"
                  label={t('account:ccme')}
                />
              </div>
              <VyButton disabled={isSubmitting || !content} showLoadingIcon={isSubmitting} type="submit">
                {t('common:send')}
              </VyButton>
            </form>
          </>
        )}
      </VyModal>
    </>
  );
}
